import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  LEAD_CONTRACTS_REFRESH: createSagaAction('LEAD_CONTRACTS_REFRESH'),

  LEAD_CONTRACT_CREATE: createSagaAction('LEAD_CONTRACT_CREATE'),
  LEAD_CONTRACT_UPDATE: createSagaAction('LEAD_CONTRACT_UPDATE'),
  LEAD_CONTRACT_DELETE: createSagaAction('LEAD_CONTRACT_DELETE'),

  // Attachments
  UPLOAD_CONTRACT_ATTACHMENT: createSagaAction('UPLOAD_CONTRACT_ATTACHMENT'),
  GET_CONTRACT_ATTACHMENTS: createSagaAction('GET_CONTRACT_ATTACHMENTS'),
  UPDATE_CONTRACT_ATTACHMENT_DESCRIPTION: createSagaAction(
    'UPDATE_CONTRACT_ATTACHMENT_DESCRIPTION'
  ),
  DELETE_CONTRACT_ATTACHMENT: createSagaAction('DELETE_CONTRACT_ATTACHMENT'),

  SET_CONTRACT_STATUS: createSagaAction('SET_CONTRACT_STATUS')
}

// Action Creators
export const actions = {
  leadContractRefresh: ({ leadId, next }) => ({
    type: constants.LEAD_CONTRACTS_REFRESH.ACTION,
    leadId,
    next
  }),

  createLeadContract: ({ leadId, content, paymentSchedule, userId }) => ({
    type: constants.LEAD_CONTRACT_CREATE.ACTION,
    leadId,
    content,
    paymentSchedule,
    userId
  }),

  updateLeadContract: ({ leadId, contractId, userId, content, paymentSchedule }) => ({
    type: constants.LEAD_CONTRACT_UPDATE.ACTION,
    leadId,
    contractId,
    userId,
    content,
    paymentSchedule
  }),

  deleteLeadContract: ({ contractId, leadId }) => ({
    type: constants.LEAD_CONTRACT_DELETE.ACTION,
    leadId,
    contractId
  }),

  // Attachment actions
  uploadAttachment: ({ formData, contractId, leadId }) => ({
    type: constants.UPLOAD_CONTRACT_ATTACHMENT.ACTION,
    formData,
    contractId,
    leadId
  }),

  getAttachments: ({ contractId }) => ({
    type: constants.GET_CONTRACT_ATTACHMENTS.ACTION,
    contractId
  }),

  updateAttachmentDescription: ({ attachmentId, currentId, description, userId }) => ({
    type: constants.UPDATE_CONTRACT_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    currentId,
    description,
    userId
  }),

  deleteAttachment: ({ attachmentId, contractId }) => ({
    type: constants.DELETE_CONTRACT_ATTACHMENT.ACTION,
    attachmentId,
    contractId
  }),

  setContractStatus: ({ status, contractId, leadId }) => ({
    type: constants.SET_CONTRACT_STATUS.ACTION,
    status,
    contractId,
    leadId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.LEAD_CONTRACTS_REFRESH.SUCCESS:
      return {
        ...state,
        leadContracts: action.payload
      }
    case constants.LEAD_CONTRACT_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_CONTRACT_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_CONTRACT_DELETE.SUCCESS:
      return {
        ...state
      }

    // Attachments
    case constants.UPLOAD_CONTRACT_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_CONTRACT_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_CONTRACT_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_CONTRACT_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        contractAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_CONTRACT_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_CONTRACT_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_CONTRACT_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }

    case constants.SET_CONTRACT_STATUS.ACTION:
      return { ...state, error: null, settingContractStatus: true }
    case constants.SET_CONTRACT_STATUS.SUCCESS:
      return {
        ...state,
        settingContractStatus: false
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/leadFunctions/leadContractActions.js